module.exports = __webpack_public_path__ + "static/media/a-7.60326c1a.jpg";